import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { EditorState } from 'draft-js';
import { richTextToHtml, richTextContentFromHtml } from '../../shared/utils/richTextHtml';

import RichEditor from '../../RichEditor/components/RichEditor';

// WYSIWYG editor for V3Offer.guarantee_notes. Mirrors the implementation
// previously embedded in V3OfferModifiersCard. Field-level autosave is
// handled by the parent pane via onChangeField (debounced PATCH).
const V3DealTermsGuaranteeNotesEditor = ({ offer, onChangeField }) => {
  const [editorState, setEditorState] = useState(() => (
    offer?.guarantee_notes
      ? EditorState.createWithContent(richTextContentFromHtml(offer.guarantee_notes))
      : EditorState.createEmpty()
  ));

  const lastSeededOfferId = useRef(offer?.id || null);
  useEffect(() => {
    if (offer?.id === lastSeededOfferId.current) return;
    lastSeededOfferId.current = offer?.id || null;
    setEditorState(
      offer?.guarantee_notes
        ? EditorState.createWithContent(richTextContentFromHtml(offer.guarantee_notes))
        : EditorState.createEmpty(),
    );
  }, [offer?.id]);

  const handleChange = (next) => {
    setEditorState(next);
    onChangeField('guarantee_notes', richTextToHtml(next.getCurrentContent()));
  };

  return (
    <div className="v3-additional-terms-card__editor">
      <RichEditor
        wrapperClassName="border-0"
        editorState={editorState}
        onEditorStateChange={handleChange}
      />
    </div>
  );
};

V3DealTermsGuaranteeNotesEditor.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.number,
    guarantee_notes: PropTypes.string,
  }).isRequired,
  onChangeField: PropTypes.func.isRequired,
};

export default V3DealTermsGuaranteeNotesEditor;
